export default __webpack_public_path__ + "static/media/audio.1f707379.svg";